import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const StyledGrid = styled(Grid)(({ theme }) => ({
  height: 56,
  marginBottom: 35,
  [theme.breakpoints.up("mobile")]: {
    height: 113,
    marginBottom: 40,
  },
  [theme.breakpoints.up("tablet")]: {
    height: 130,
    marginBottom: 45,
  },
}));

export const Logo = styled("img")(() => ({
  height: "100%",
}));
